import { BillingDocumentIntegrationStatus } from "constants/billingDocuments";

export const billingDocumentAllowsReversal = billingDocument =>
  [
    BillingDocumentIntegrationStatus.AUTHORISED,
    BillingDocumentIntegrationStatus.PAID,
  ].includes(billingDocument.integrationStatus);
